import React from "react";
import { useTheme } from "@mui/material/styles";
// sections
import { HeroSection } from "Sections/AboutUs";
import { FeatureWithSteps, SingleColFeature, CallToAction } from "Sections/features";
import TestimonialSlider from "./TestimonalSlider";
import mission from "../../assets/images/webisteimage/c1.jpg";
import aboutUs from "../../assets/images/webisteimage/c3.jpg";

import {
  WhyNBTConfig,
  VisionConfig,
  SafetyConfig,
  CTAConfig,
  AboutConfig,
  MissionConfig,
  ObjectiveConfig,
  ClientConfig,
  MSGConfig,
} from "./config";
import GmMessage from "Sections/features/GmMessage";
import { ClientsList } from "Sections/features";

function Home() {
  const theme = useTheme();
  return (
    <div id="about">
      {/* <HeroSection id="TheHero" /> */}
      <FeatureWithSteps
        heading={<>{AboutConfig.head}</>}
        description={AboutConfig.desc}
        white
        changeContainer={false}
        imageUrl={aboutUs}
        imageOnLeft={false}
      />

      <FeatureWithSteps heading={<>{VisionConfig.head}</>} description={VisionConfig.desc} />
      <FeatureWithSteps
        heading={<>{MissionConfig.head}</>}
        description={MissionConfig.desc}
        white
        changeContainer={false}
        imageUrl={mission}
      />
      {/* <FeatureWithSteps heading={<>{ObjectiveConfig.head}</>} description={ObjectiveConfig.desc} /> */}
      {/* <SingleColFeature heading={WhyNBTConfig.head} description={WhyNBTConfig.desc} white /> */}

      <GmMessage heading={MSGConfig.head} description={MSGConfig.desc} />
      {/* <FeatureWithSteps
        heading={<>{SafetyConfig.head}</>}
        description={SafetyConfig.desc}
        steps={SafetyConfig.steps}
        zero
      /> */}
      <ClientsList heading={<>{ClientConfig.head}</>} steps={ClientConfig.steps} zero />
      {/* <CallToAction heading={CTAConfig.head} description={CTAConfig.desc} /> */}
      <TestimonialSlider />
    </div>
  );
}

export default Home;
